// Angular
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'trim'
})
export class TrimPipe implements PipeTransform {

	constructor(
	) {
	}

	transform(value: string) {
        return value.trim();
    }
}